























































































import { computed, defineComponent, getCurrentInstance, ref } from '@vue/composition-api';
import { UserIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import { can } from '@/renderer/scripts/composition/authHandler';
import openPreviewHandler from '@/renderer/components/SpacePage/compositions/openPreviewHandler';
import { SMH } from '@/renderer/scripts/smh';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import {
  noPreview,
  isAllowPreviewImage,
  isAllowPrivate,
  isAllowEditDoc,
} from '@/renderer/scripts/composition/allowPreview';
import tips from '@/renderer/scripts/utils/tips';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
interface Props {
  data: SMH.ColleborationSpaceInfoData & {
    checked: boolean;
    authorityList: SMH.AuthorityList;
  };
}
export default defineComponent({
  name: 'CoSpaceCard',
  components: {
    UserIcon,
  },
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  setup(props: Props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const masterName = computed(() => props.data.ownerName || '');
    const files = computed(() => props.data.directoryList || []);
    const spaceId = computed(() => props.data.spaceId);
    const rootAuth = computed(() => props.data.authorityList); // 添加根目录权限项
    const isShowDrawer = computed(() => vm.$store.getters.drawerShow);
    const isOwner = computed(
      () => Number(props.data.orgId) === vm.$store.getters.orgId && props.data.ownerId === vm.$store.getters.userId,
    );
    const { methods: previewMethods } = openPreviewHandler(spaceId, ref(props.data.orgId));
    // 1、企业版/团队版发起的协作空间，允许包含外部成员时，群主及内部成员看群组标识为【外部共享】，外部成员看标识为创建者的公司名
    // 2、个人版创建的群组
    // 无成员加入，仅群主创建者一人——创建者展示群组标识应该为【内部共享】
    // 有个人版成员加入——创建者和成员展示群组标识都为应该为【外部共享】
    // 有团队版/企业版成员加入——该群组在群主和成员端都应该展示为【外部共享】
    const groupTag = computed(() => {
      if (props.data.orgName === i18n_t('个人版') && props.data.userCount > 1) return i18n_t('外部共享');
      if (!props.data.isExternal && !props.data.hasCrossOrgUser) {
        return i18n_t('内部共享');
      }
      if (props.data.orgId === vm.$store.getters.orgId && (props.data.hasCrossOrgUser || props.data.isExternal)) {
        return i18n_t('外部共享');
      }
      return props.data.orgName || i18n_t('外部共享');
    });
    const openCoSpace = (params: SMH.GetColleborationSpaceInfoData, secondJumpPath?: string): void => {
      const query: Record<string, string> = {
        spaceId: params.spaceId,
        id: params.id.toString(),
        name: params.name,
        spaceOrgId: params.orgId.toString(),
      };
      if (secondJumpPath) {
        query.path = secondJumpPath;
      }
      const route: Record<string, any> = {
        name: 'collaborationSpaceList',
        query,
      };
      if (isOwner.value) {
        route.params = {
          isOwner: 'isOwner',
        };
      }
      dispatchRouter(route);
    };
    const onOpenCoSpace = (event?: Event, params?: SMH.ColleborationSpaceInfoData) => {
      const target = event?.target as HTMLElement;
      if (typeof target?.className === 'string' && target?.className.includes('radio')) {
        context.emit('select', props.data);
        return;
      }
      reporter.report('group', {
        group_persons: props.data.userCount,
        group_files: props.data.fileCount,
      });
      const data = params || props.data;
      openCoSpace(data);
    };

    /**
     * 按设计要求，除点击单选框为选中群组，其余点击则进入群组二级页
     */
    const onSelectItem = (event: Event) => {
      const group = props.data;
      // 进入群组二级页, 先判断该群组有无过期
      if (group.orgExpired) {
        tips.error(i18n_t('邀请企业已过期，续费成功后该群组方可正常使用!'));
        return;
      }
      vm.$store.commit(DrawerEvents.SET_SELECTEDLIST, [group]);
      onOpenCoSpace(event);
    };
    const openItem = (item: any) => {
      const group = props.data;
      if (group.orgExpired) {
        tips.error(i18n_t('邀请企业已过期，续费成功后该群组方可正常使用!'));
        return;
      }
      if (item.type === 'dir') {
        // 一级目录下跳转文件夹下
        vm.$store.commit(DrawerEvents.SET_SELECTEDLIST, [props.data]);
        openCoSpace(props.data, item.name);
      } else if (noPreview(item)) {
        tips.error(i18n_t('该格式暂不支持在线预览'));
      } else if (!can('Preview', item)) {
        tips.error(i18n_t('暂无在线预览权限，请联系管理员'));
      } else if (isAllowPreviewImage(item.name) && item?.size >= ConstantConfig.ciImageMaxSize) {
        tips.error(i18n_t('文件过大，请下载至本地查看'));
      } else if (!vm.$store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
        if (isAllowEditDoc(item.name)) {
          tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
        } else {
          tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
        }
      } else {
        item.path = [item.name];
        previewMethods.openPreview(item, 1);
      }
    };
    const removeClass = (obj: HTMLElement, className: string) => {
      if (obj?.className?.indexOf?.(className) > -1) {
        const newClass = obj.className.replace(className, '');
        obj.className = newClass.replace(/(^\s*)/g, '');
      }
    };
    const addClass = (obj: HTMLElement, className: string) => {
      if (obj?.className?.indexOf?.(className) === -1) {
        if (obj.classList) {
          obj.classList.add(className);
        } else {
          obj.className += ` ${className}`;
        }
      }
    };
    const mouseenter = (event: Event) => {
      const { cospaceCard } = vm.$refs;
      addClass(cospaceCard as HTMLElement, 'pointerhover');
    };
    const mouseleave = (event: Event) => {
      const { cospaceCard } = vm.$refs;
      removeClass(cospaceCard as HTMLElement, 'pointerhover');
      event.stopPropagation();
    };
    const uploadFile = () => {
      const group = props.data;
      if (group.orgExpired) {
        tips.error(i18n_t('邀请企业已过期，续费成功后该群组方可正常使用!'));
        return;
      }
      // 去上传按钮跳转目录
      vm.$store.commit(DrawerEvents.SET_SELECTEDLIST, [props.data]);
      openCoSpace(props.data);
    };
    const emitInvite = (event: Event) => {
      if (!isOwner.value) return;
      const group = props.data;
      if (!group.checked) {
        context.emit('select', props.data);
      }
      context.emit('invite');
      event.stopPropagation();
    };

    const radioChange = (e: { e: Event }) => {
      e.e.stopPropagation();
      vm.$store.commit(DrawerEvents.SET_SELECTEDLIST, [props.data]);
      context.emit('select', props.data);
    };
    return {
      masterName,
      files,
      groupTag,
      isShowDrawer,
      onOpenCoSpace,
      onSelectItem,
      openItem,
      mouseenter,
      mouseleave,
      uploadFile,
      emitInvite,
      isOwner,
      rootAuth,
      radioChange,
    };
  },
});
